import { render } from "./StyledSelect.vue?vue&type=template&id=5b652cb4"
import script from "./StyledSelect.vue?vue&type=script&lang=js"
export * from "./StyledSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__